import Server from "src/server";
import Util from "src/util/util";

export default
{
  namespaced: true,
  state:
  {
    isLoading: false,
    // This is different from the other workspaces. It contains both a workspace
    // as a key, as well as all workflows in that workspace. Only loads for admins,
    // and objectively is not that much data. Allows for the summary page.

    // @todo:cs add the extra stuff for this. Pull all the workflows
    // with the key being the workspace name.
    workspaces: [],
  },

  mutations:
  {

  },

  actions:
  {
    reset(context)
  {
      context.state.workflows = [];
    },

    async getWorkspaces(context) {
      try {
        context.state.isLoading = true;

        const list = context.rootState.wsStore.workspaces;
        for (const workspace of list) {
          var result = await Server.post("getWorkflows", { workspace }).promise;
          if(!result.data.success)
            throw(result.data.error);

          //
          //  If workfows do not have the webhooks setting enabled
          //  we need to default it to true.
          //
          for (var wf of result.data.workflows) {
            if (wf.webhookEnabled === null || wf.webhookEnabled === undefined) {
              wf.webhookEnabled = true;
            }
          }
          context.state.workspaces.push({name: workspace.name, workflows: result.data.workflows});
        }
        context.state.isLoading = false;
      }
      catch(e) {
        console.log("Failed 'getWorkflows' server call. " + e.toString());
        context.state.isLoading = false;
        return {data:{success: false, error: e}};
      }
    },

  },

  getters:
  {

  },
};



// WEBPACK FOOTER //
// ./src/store/summary.js